import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import {
    weekDays, 
    getDateTime, 
    getDateEndFromWeekNum, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum2, 
    MyDate, 
    myAxios, 
    MyFormData, 
    outsideWorkingOns, 
    outsideNotWorkingReasons, 
    isDevMode, 
    weeknum, 
    buildWeekNumArray, 
    getTimeStamp, 
    standbyStartDate as startDate, 
    outsideDailydefaultEmptyData as defaultEmptyData,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DailyCallOut({ tabTitle }){
    const timeValid = (week, i) => getDateTime(week, i, 7, 30) > new Date();
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = path.split("/")[1];
    const path2 = path.split("/")[2];
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const [weeks] = useState(buildWeekNumArray(startDate).filter(week => (
        (getDateTime(week, 7, 0, 0) > (new Date(user.hireDate.replace(/-/g, "/")))) && 
        (user.quitDate?(getDateTime(week, 0, 0, 0) <= (new Date(user.quitDate.replace(/-/g, "/")))):true)
    )).reverse());
    const [week, setWeek] = useState(() => weeks.includes(path2)?path2:(
        weeks.includes(weeknum((new MyDate()).s()))?weeknum((new MyDate()).s()):
        (weeks.length?weeks[0]:"")
    ));
     //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const forms = useMyStore(state => state.outsideserviceIndividualDailyForms);
    const setForms = useMyStore(state => state.setOutsideserviceIndividualDailyForms);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore((state) => state.setOutsideserviceLocatorDivisions);
    const form = forms[week] ?? {};
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt, 
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [isEdittingContent, setIsEdittingContent] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            // ------------------------------
            setShowLoading(true);
            const resDivisions = await myAxios("outside/divisions/readDivisions.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resDivisions) return;
            // ------------------------------
            setDivisions(resDivisions.data, updateDateTime["Divisions"]);
        }
        if(updateDateTime["Divisions"] !== divisions.updatedAt) getData();
        return () => {isMounted = false;}
    },[updateDateTime["Divisions"]])
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            //-------------------------------------
            const formData = new MyFormData();
            formData.append("week", week);
            formData.append("action", "Read");
            setShowLoading(true);
            const res = await myAxios("outside/daily/daily.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------
            setForms(week, JSON.parse(res.data[week] || defaultEmptyData), updateDateTime["Forms"]);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {isMounted = false;}
    },[history, updateDateTime["Forms"], week])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setIsEdittingContent(false);
                            setWeek(e.currentTarget.value);
                            history.push(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                JSON.stringify(form) === "{}"?<div className = "cssLoading">Empty</div>:
                <form
                    className = "p-1"
                    onSubmit = {async e => {
                        e.preventDefault();
                        const formData = new MyFormData();
                        formData.append("currentWeek", week);
                        formData.append("data", JSON.stringify(form));
                        //----------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("outside/daily/daily.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //----------------------------------------------------------------
                        setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                        setIsEdittingContent(false);
                    }}
                >
                    <div className = "h3 text-danger font-weight-bold">{getDateEndFromWeekNum(week)}</div>
                    <div className = "h5 font-weight-bold">Job Hazard Analysis Check</div>
                    <li>
                        Error-likely with job site
                        <ul>
                            <li>Unfamiliarity with job site</li>
                            <li>Distractions / interruptions</li>
                        </ul>
                    </li>
                    <li>
                        Pre Job Brief
                        <ul>
                            <li>Did I identity all hazards?</li>
                            <li>Do I need assistance?</li>
                            <li>How do I prepare for what cound go wrong?</li>
                        </ul>
                    </li>
                    <li>
                        Routine Activities
                        <ul>
                            <li>Avoid "auto-pilot"</li>
                            <li>Stay engaged in the task at hand</li>
                        </ul>
                    </li>
                    <li>
                        Questioning Attitude
                        <ul>
                            <li>Stop, look and listen</li>
                            <li>Do not make assumptions</li>
                        </ul>
                    </li>
                    <li>
                        Weather Conditions
                        <ul>
                            <li>Did I identity weather hazards</li>
                        </ul>
                    </li>
                    <li>
                        360 Vehicle Inspection
                    </li>
                    <div className = "row">
                        {weekDays.map((weekday, i) => 
                        <div className = "col-lg" key = {i}>
                            <div className = "mt-2 h4 text-secondary">{weekday} ({getDatefromWeekNum(week, i)}) </div>
                            {!timeValid(week, i) && !form.form[i].unlock?
                            <div className = "text-center"><span className = "badge badge-primary">past</span></div>
                            :null}
                            <div className = "mt-2">
                                <input id = {`acknowledge ${i}`} className = "cssCheckBox mt-2" type = "checkbox" disabled = {!(isEdittingContent && (timeValid(week, i) || form.form[i].unlock))} 
                                checked = {form.form[i].acknowledged} onChange = {e => {
                                    setForms(week, {
                                        ...form, 
                                        form: form.form.map(
                                            (
                                                (ff, weekday) => weekday === i?
                                                (e.currentTarget.checked?{
                                                    ...ff, 
                                                    acknowledged: e.currentTarget.checked
                                                }:{
                                                    acknowledged: e.currentTarget.checked
                                                }):ff
                                            )
                                        )
                                    });
                                }}/><label htmlFor = {`acknowledge ${i}`} className = "d-inline mb-0 ml-2">I acknowledge that I understand and will apply the above JHA to every ticket.</label>
                            </div>
                            {form.form[i].acknowledged?<>
                            {form.form[i].working !== "" || (isEdittingContent && (timeValid(week, i) || form.form[i].unlock))?
                            <label htmlFor = {`working ${i}`} className = "font-weight-bold mt-2 mb-0">Working:</label>
                            :null}
                            {isEdittingContent && (timeValid(week, i) || form.form[i].unlock)?
                                <select id = {`working ${i}`} className = "form-control"
                                    value = {form.form[i].working}
                                    onChange = {e => {
                                        setForms(week, {
                                            ...form, 
                                            form: form.form.map(
                                                (
                                                    (ff, weekday) => weekday === i?
                                                    ({
                                                        ...ff, 
                                                        working: e.currentTarget.value
                                                    }):ff
                                                )
                                            )
                                        });
                                    }}
                                >
                                    <option value = "">Select</option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                                :
                                <span className = "ml-2">
                                    {form.form[i].working}
                                </span>
                            }
                            {form.form[i].working === "Yes"?<>
                            <div className = "mt-2">
                                <label htmlFor = {`commuteOrHotel ${i}`} className = "font-weight-bold">Commute or Hotel:</label>
                                {isEdittingContent && (timeValid(week, i) || form.form[i].unlock)?
                                <div>
                                    <select id = {`commuteOrHotel ${i}`} className = "form-control" required
                                        value = {form.form[i].commuteOrHotel}
                                        onChange = {e => {
                                            setForms(week, {
                                                ...form, 
                                                form: form.form.map(
                                                    (
                                                        (ff, weekday) => weekday === i?
                                                        ({
                                                            ...ff, 
                                                            commuteOrHotel: e.currentTarget.value
                                                        }):ff
                                                    )
                                                )
                                            });
                                        }}
                                    >
                                        <option value = "">Select</option>
                                        <option>Commute</option>
                                        <option>Hotel</option>
                                    </select>
                                </div>
                                :
                                <span className = "ml-2">
                                    {form.form[i].commuteOrHotel}
                                </span>
                                }
                            </div>
                            <div className = "mt-2">
                                <label htmlFor = {`divison ${i}`} className = "font-weight-bold">Division:</label>
                                {isEdittingContent && (timeValid(week, i) || form.form[i].unlock)?
                                <select id = {`divison ${i}`} className = "form-control" required
                                    value = {form.form[i].division}
                                    onChange = {e => {
                                        setForms(week, {
                                            ...form, 
                                            form: form.form.map(
                                                (
                                                    (ff, weekday) => weekday === i?
                                                    ({
                                                        ...ff, 
                                                        division: e.currentTarget.value
                                                    }):ff
                                                )
                                            )
                                        });
                                    }}
                                >
                                    <option value = "">Select</option>
                                    {divisions.data.map((d, key) => <option key = {key}>{d.division}</option>)}
                                </select>
                                :
                                <span className = "ml-2">
                                    {form.form[i].division}
                                </span>
                                }
                            </div>
                            <div className = "mt-2">
                                <label htmlFor = {`workingOn ${i}`} className = "font-weight-bold">Working On:</label>
                                {isEdittingContent && (timeValid(week, i) || form.form[i].unlock)?
                                    <select id = {`workingOn ${i}`} className = "form-control" required
                                        value = {form.form[i].workingOn}
                                        onChange = {e => {
                                            setForms(week, {
                                                ...form, 
                                                form: form.form.map(
                                                    (
                                                        (ff, weekday) => weekday === i?
                                                        ({
                                                            ...ff, 
                                                            workingOn: e.currentTarget.value
                                                        }):ff
                                                    )
                                                )
                                            });
                                        }}
                                    >
                                        <option value = "">Select</option>
                                        {outsideWorkingOns.map((w, i) => <option>{w}</option>)}
                                    </select>
                                    :
                                    <span className = "ml-2">
                                        {form.form[i].workingOn}
                                    </span>
                                }
                            </div>
                            </>:null}
                            {form.form[i].working === "No"?
                            <div className = "mt-2">
                            <label htmlFor = {`reason ${i}`} className = "font-weight-bold">Reason:</label>
                            {isEdittingContent && (timeValid(week, i) || form.form[i].unlock)?
                                <div>
                                    <select id = {`reason ${i}`} className = "form-control" required
                                        value = {form.form[i].notWorkingReason}
                                        onChange = {e => {
                                            setForms(week, {
                                                ...form, 
                                                form: form.form.map(
                                                    (
                                                        (ff, weekday) => weekday === i?
                                                        ({
                                                            ...ff, 
                                                            notWorkingReason: e.currentTarget.value
                                                        }):ff
                                                    )
                                                )
                                            });
                                        }}
                                    >
                                        <option value = "">Select</option>
                                        {outsideNotWorkingReasons.map((r, i) => <option key = {i}>{r}</option>)}
                                    </select>
                                </div>
                                :
                                <span className = "ml-2">
                                    {form.form[i].notWorkingReason}
                                </span>
                            }
                        </div>
                        :null
                        }
                        </>:null}
                        </div>)}
                    </div>
                    {new Date(getDateEndFromWeekNum2(week)) >= new Date()?
                    <div className = "mt-2 text-right">
                        {isEdittingContent?
                        <button
                            type = "submit"
                            value = "Submit"
                            className = "btn btn-info"
                        >
                            Save Content
                        </button>:
                        <span className = "btn btn-info"
                            onClick = {() => {
                                setIsEdittingContent(true);
                                setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                            }}
                        >
                            Edit Content
                        </span>
                        }
                    </div>
                    :<></>}
                </form>}
            </div>
        </div>
    )
}